function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20047330_153739)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 16,
  fill: "black"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 24,
  cy: 23.9346,
  rx: 24,
  ry: 23.9346,
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.875 37.5L29.3464 28.8214H37.2857V25.5429H11.25V28.8214H19.1893L13.6607 37.5H17.775L24.2679 27.3107L30.7607 37.5H34.875ZM37.2857 22.3607V19.0821H29.5071L34.9714 10.5H30.825L24.2679 20.85L17.7107 10.5H13.5643L19.0286 19.0821H11.25V22.3929L37.2857 22.3607Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20047330_153739"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 16,
  fill: "white"
})));
function SvgHiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiro);
export default __webpack_public_path__ + "static/media/hiro.6b433d47c6f5f14bcdfd56218d415ec4.svg";
export { ForwardRef as ReactComponent };